import React from 'react';
import { 
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    SearchInput,
    EditButton,
    ShowButton
} from 'react-admin';
import jwt_decode from 'jwt-decode'
import ErrorBoundary from '../ErrorBoundary';


let level =  (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 );

export const RegistrationFilter = props => (
    <Filter {...props}>
        <SearchInput source="l_name" alwaysOn placeholder='Last Name'/>
        <TextInput source="f_name" label="First Name" />
        <DateInput source="created_date" label="Date" locales="en-us"/>
        <TextInput source="zip" label="Zip code" />
        <TextInput source="don_ph" label="Phone" />
        
    </Filter>
);

export const RegistrationList = props => (
    <ErrorBoundary>
        <List 
            {...props}
            filters={<RegistrationFilter />}
            perPage={20}
            sort={{ field: 'name', order: 'DESC' }}
            bulkActionButtons ={false}
            
            >
            <Datagrid  >
                <TextField source="name" label="Name" />
                <TextField source="address" label="Address" />      
                <TextField source="don_ph" label="Phone" />
                <DateField source="created_date" label="Date"  locales="en-us"/>
                {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 1 && 
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 3 &&
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 4 &&
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 5  &&
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 6 && <ShowButton  label=''/> }
                
                {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 1 &&
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 3 &&
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 4 && 
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 5 &&
                (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) != 6 && <EditButton label='' />}
                
            </Datagrid>
        </List>
    </ErrorBoundary>
);


export default RegistrationList